'use client';
import { toast } from '@/components/ui/use-toast';
import { subscribeToStream } from '@/helpers/fetcher';
import { useRef, useState } from 'react';

export type BulkSender = {
    id: string,
    channel: string | 'unofficial_personal_wpp',
    state: { sent: number, status: 'start_process' | 'processing' | 'finished' },
    contacts: string[],
    message: {
        text?: { body?: string },
        attachment?: {
            type: 'audio' | 'image' | 'file' | 'video',
            lastModified?: number,
            mimetype?: string,
            filename?: string,
            size?: number,
            path?: string
        }
    }
};

export default function useBulkSender() {
    const bulkSendersRef = useRef<Map<string, BulkSender>>(new Map());
    const [_, forceRerender] = useState<number>(0);

    const onHandleBulkSender = async (
        contacts: string[],
        channel: string | 'unofficial_personal_wpp',
        message: BulkSender['message']
    ) => {
        const id = Date.now().toString();
        const bulkSendersMap = new Map(bulkSendersRef.current);
        const senderObject: BulkSender = {
            state: { sent: 0, status: 'start_process' },
            contacts,
            channel,
            message,
            id
        };

        bulkSendersMap.set(id, senderObject);
        bulkSendersRef.current = bulkSendersMap;
        forceRerender((v) => v + 1);

        try {
            subscribeToStream({
                url: '/crm/bulk/interactions/stream',
                isApiWpp: true,
                withAuth: true,
                method: 'POST',
                options: {
                    body: JSON.stringify({ contacts, channel, message }),
                    headers: { 'Content-Type': 'application/json' }
                },
                onEventReceived(data) {
                    if (typeof data === 'object' && data.status) {
                        const latestMap = new Map(bulkSendersRef.current);
                        const sender = latestMap.get(id);

                        if (sender) Object.assign(sender.state, data as BulkSender['state']);

                        console.log(data);

                        if (data.status == 'finished') latestMap.delete(id);
                        bulkSendersRef.current = latestMap;
                        forceRerender((v) => v + 1);
                    }
                }
            });
        } catch {
            toast({
                variant: 'destructive',
                title: 'Error de conexión',
                description: 'No se pudo completar la solicitud debido a un problema en el servidor o una falla en la conexión de red. Verifica tu conexión a Internet e inténtalo nuevamente. Si el problema persiste, contacta al soporte técnico.',
            });
        }
    };

    return {
        bulkSenders: bulkSendersRef.current,
        onHandleBulkSender
    }
}